/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Identifier type used to route e-invoices to a client (France only). SIRET is not supported for now.
 * @export
 */
export const EInvoiceIdentifierType = {
    Siren: 'SIREN',
    Vat: 'VAT',
    RoutingSuffix: 'ROUTING_SUFFIX'
} as const;
export type EInvoiceIdentifierType = typeof EInvoiceIdentifierType[keyof typeof EInvoiceIdentifierType];


export function instanceOfEInvoiceIdentifierType(value: any): boolean {
    for (const key in EInvoiceIdentifierType) {
        if (Object.prototype.hasOwnProperty.call(EInvoiceIdentifierType, key)) {
            // @ts-ignore
            if (EInvoiceIdentifierType[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function EInvoiceIdentifierTypeFromJSON(json: any): EInvoiceIdentifierType {
    return EInvoiceIdentifierTypeFromJSONTyped(json, false);
}

export function EInvoiceIdentifierTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): EInvoiceIdentifierType {
    return json as EInvoiceIdentifierType;
}

export function EInvoiceIdentifierTypeToJSON(value?: EInvoiceIdentifierType | null): any {
    return value as any;
}

